<template>
  <div>
  <spinner :spinnerOn="loading"></spinner>
  <div class="modal reactivatedxpnewmodal" role="dialog" aria-hidden="true" style="z-index:9999">
	  <div class="modal-dialog">
      <div class="modal-content" style="color: #00524A;">
        <div class="modal-header" style="display: block;">
		      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">{{user_lang.reactivate}}</div>
            <button type="button" class="close" data-dismiss="modal" @click.prevent="closeModal('.reactivatedxpnewmodal')">&times;</button>
		        <h4 style="font-size: 18px;"></h4>
          </div>
          <div class="modal-body">
		        <div style="margin-right: 233px;width: 100%;text-align: left;">
		          <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		          {{dxpnewcurrentName}} </label>
		        </div>
		        <input class="form-control col-lg-12 col-md-12 col-sm-12 col-xs-12" id="message-text" type="hidden" v-model="dxpnewcurrentId"></input>
		        <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="sendNewDxpReInvite" style="margin-top: 15px;">{{user_lang.yes}}</a>
		        <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="closeModal('.reactivatedxpnewmodal')" data-dismiss="modal" style="margin-top: 15px;">{{user_lang.no}}</a>
	      </div>
	    </div>
	  </div>
  </div>
  <div class="modal adminErrorModal" role="dialog" aria-hidden="true" style="z-index:9999">
	  <div class="modal-dialog">
      <div class="modal-content" style="color: #00524A;">
        <div class="modal-header" style="display: block;">
		      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">
            Error
          </div>
          <button type="button" class="close" data-dismiss="modal" @click.prevent="closeModal('.adminErrorModal')">&times;</button>
		      <h4 style="font-size: 18px;"></h4>
        </div>
        <div class="modal-body">
		      <div style="margin-right: 233px;width: 100%;text-align: left;">
		        {{errorAdminMsg}}
		      </div>
		      <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="adminErrorModalClick" style="margin-top: 15px;">{{user_lang.activationOk}}</a>
        </div>
	    </div>
	  </div>
  </div>
	<div class="modal resetpwdemodal" role="dialog" aria-hidden="true">
	<div class="modal-dialog">
        <div class="modal-content" style="color: #00524A;">
          <div class="modal-header" style="display: block;">
		  <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">{{user_lang.resetpwd}}</div>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
		  <h4 style="font-size: 18px;"></h4></div>
          <div class="modal-body">
		   <div style="margin-right: 233px;width: 100%;text-align: left;">
		  <label v-show="!resetSuccess" for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		  {{user_lang.wanttoreset}} </label>
		  <label v-show="resetSuccess" for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		  {{resetSuccessMsg}}</label>
		  </div>
		  <input class="form-control col-lg-12 col-md-12 col-sm-12 col-xs-12" id="message-text" type="hidden" v-model="currentId"></input>
		  <a v-show="!resetSuccess" class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="resetPassword" style="margin-top: 15px;">
		  {{user_lang.yes}}</a>
		  <a v-show="!resetSuccess" class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" data-dismiss="modal" style="margin-top: 15px;">
		  {{user_lang.no}}</a>
		  <a v-show="resetSuccess" class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" data-dismiss="modal" style="margin-top: 15px;">
		  {{user_lang.close}}</a>
          <!--div class="col-12" style="margin-bottom: 15px;color: green;" v-show="resetSuccess"> Successfully Updated. </div -->
	  </div>
	  </div>
	  </div>
    </div>
	<div class="modal reactivatemodal" role="dialog" aria-hidden="true" style="z-index:9999">
	<div class="modal-dialog">
        <div class="modal-content" style="color: #00524A;">
          <div class="modal-header" style="display: block;">
		  <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">{{user_lang.reactivate}}</div>
        <button type="button" class="close" data-dismiss="modal" @click.prevent="closeModal('.reactivatemodal')">&times;</button>
		  <h4 style="font-size: 18px;"></h4></div>
          <div class="modal-body">
		   <div style="margin-right: 233px;width: 100%;text-align: left;">
		  <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		  {{user_lang.wanttoreactivate}} </label>
		  </div>
		  <input class="form-control col-lg-12 col-md-12 col-sm-12 col-xs-12" id="message-text" type="hidden" v-model="currentId"></input>
		  <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="sendReInvite" style="margin-top: 15px;">{{user_lang.yes}}</a>
		  <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="closeModal('.reactivatemodal')" data-dismiss="modal" style="margin-top: 15px;">{{user_lang.no}}</a>
          <!--div class="col-12" style="margin-bottom: 15px;color: green;" v-show="resetSuccess"> Successfully Updated. </div -->
	  </div>
	  </div>
	  </div>
    </div>
  
  <div class="modal dxpmodal" role="dialog" 
  aria-hidden="true" style="z-index:9999">
	  <div class="modal-dialog">
      <div class="modal-content" style="color: #00524A;">
        <div class="modal-header" style="display: block;">
		      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">
            {{user_lang.activationTitle}}
          </div>
          <button type="button" class="close" data-dismiss="modal" @click.prevent="closeModal('.dxpmodal')">&times;</button>
		      <h4 style="font-size: 18px;"></h4>
        </div>
        <div class="modal-body">
		      <div style="margin-right: 233px;width: 100%;text-align: left;">
		        <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		        {{user_lang.activationDescription}} </label>
		      </div>
          <div style="margin-right: 233px;width: 100%;text-align: left;" v-for = "data in dxpList">
            <input type="radio"  
            v-bind:id="data.id"
            name="activation"
            v-bind:value="data.id">
            <label 
            v-bind:for="data.id"> {{data.label}} {{user_lang.template}}</label>
          </div>
          <div style="margin-right: 233px;width: 100%;text-align: left;" 
          v-for="(data, index) in nonDxpList"
          v-if = "index === 0">
            <input type="radio"  
            v-bind:id="data.id"
            name="activation"
            checked="checked"
            v-bind:value="0">
            <label 
            v-bind:for="data.id">{{user_lang.cargillActivation}}</label>
          </div>
		      <input class="form-control col-lg-12 col-md-12 col-sm-12 col-xs-12" id="message-text" type="hidden" v-model="currentId"></input>
		      <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="sendDxpReInvite" style="margin-top: 15px;">{{user_lang.activationOk}}</a>
        </div>
	    </div>
	  </div>
  </div>
  <div class="modal newdxpmodal" role="dialog" 
  aria-hidden="true" style="z-index:9999">
	  <div class="modal-dialog">
      <div class="modal-content" style="color: #00524A;">
        <div class="modal-header" style="display: block;">
		      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">
            {{user_lang.activationTitle}}
          </div>
          <button type="button" class="close" data-dismiss="modal" @click.prevent="closeModal('.newdxpmodal')">&times;</button>
		      <h4 style="font-size: 18px;"></h4>
        </div>
        <div class="modal-body">
		      <div style="margin-right: 233px;width: 100%;text-align: left;">
		        <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		        {{user_lang.activationDescription}} </label>
		      </div>
          <div style="margin-right: 233px;width: 100%;text-align: left;" v-for = "data in dxpList">
            <input type="radio"  
            v-bind:id="data.id"
            name="activation"
            v-bind:value="data.id">
            <label 
            v-bind:for="data.id"> {{data.label}} {{user_lang.template}}</label>
          </div>
		      <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="sendDxpReInvite" style="margin-top: 15px;">{{user_lang.activationOk}}</a>
        </div>
	    </div>
	  </div>
  </div>
  <div class="modal permissiondeniedreset" role="dialog" aria-hidden="true">
	<div class="modal-dialog">
        <div class="modal-content" style="color: #00524A;">
		<button type="button" class="close" data-dismiss="modal" style="text-align: right; margin: 10px 20px 0px;">&times;</button>
          <div class="modal-body" style="width: 90%;">
		   <div style="text-align: left;">
		  <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		  {{user_lang.permissiondeniedreset}} </label>
		  </div>
	  </div>
	  </div>
	  </div>
    </div>
	<div class="modal permissiondeniedmodal" role="dialog" aria-hidden="true">
	<div class="modal-dialog">
        <div class="modal-content" style="color: #00524A;">
		<button type="button" class="close" data-dismiss="modal" style="text-align: right; margin: 10px 20px 0px;">&times;</button>
          <div class="modal-body" style="width: 90%;">
		   <div style="text-align: left;">
		  <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		  {{user_lang.permissiondenied}} </label>
		  </div>
	  </div>
	  </div>
	  </div>
    </div>
	<div class="modal nonanoktausermodal" role="dialog" aria-hidden="true">
	<div class="modal-dialog">
        <div class="modal-content" style="color: #00524A;">
		<button type="button" class="close" data-dismiss="modal" style="text-align: right; margin: 10px 20px 0px;">&times;</button>
          <div class="modal-body" style="width: 90%;">
		   <div style="text-align: left;">
		  <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
		  {{user_lang.nonanoktauser}} </label>
		  </div>
	  </div>
	  </div>
	  </div>
    </div>
	<div class="modal ativateanddeactivaeemodal" role="dialog" aria-hidden="true">
	<div class="modal-dialog">
        <div class="modal-content" style="color: #00524A;">
          <div class="modal-header" style="display: block;">
		  <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9" style="font-weight:bold;float: left;width: 90%;">
		  {{requestType === 'deleteoktauser' ? user_lang.delete : statusCode==0 ? user_lang.activateDeactivate.split('/')[0] : user_lang.activateDeactivate.split('/')[1]}}</div>
		  <button type="button" class="close" data-dismiss="modal">&times;</button></div>
		  <div class="modal-body" style="display: block;">
		  <div  style="margin-right: 233px;width: 100%;text-align: left;" v-show="statusCode==0">
		    <label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
			{{user_lang.wanttoactivate}}</label>
		  </div>
		  <div style="margin-right: 233px;width: 100%;text-align: left;" v-show="statusCode==1">
			<label for="message-text" class="form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" style="font-size: 18px;font-weight:normal !important;">
			{{requestType === 'deleteoktauser' ? user_lang.wanttodelete : user_lang.wanttodeactivate}}</label>
	  </div>
		  <input class="form-control col-lg-12 col-md-12 col-sm-12 col-xs-12" id="message-text" type="hidden" v-model="statusCode"></input>
		  <input class="form-control col-lg-12 col-md-12 col-sm-12 col-xs-12" id="message-text" type="hidden" v-model="currentemailId"></input>
		  <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" @click.prevent="deactivateUser" style="margin-top: 15px;">
		  {{user_lang.yes}}</a>
		  <a class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12" href="#" data-dismiss="modal" style="margin-top: 15px;">{{user_lang.no}}</a>
		  <h4 style="font-size: 18px;"></h4></div>
          <!--div class="modal-footer" v-show="updateSuccess">
      <div class="col-12" style="margin-bottom: 15px;color: green;"> Successfully Updated. </div>
	  </div :externalSearchQuery="searchTerm" -->
	  </div>
	  </div>
    </div>
	<div class="showingnusers" v-show="totalCount !== '' && !groupDeleted"
	v-bind:class="{'v-hidden' : showfloatingcount}" style="padding-top: 10px;text-align: center;font-size: 14px;background: #fff;margin: 0px -15px;">
	{{user_lang.showing}} 1 - {{rows.length}} {{user_lang.of}} {{totalCount}} {{user_lang.userword}}</div>
	<div class="outOfView" v-show = "totalCount !== ''" 
	v-bind:class="{'v-hidden' : !showfloatingcount}" style="padding-top: 10px;text-align: center;font-size: 14px;background: #fff;margin: 0px -15px;">
	{{user_lang.showing}} 1 - {{rows.length}} {{user_lang.of}} {{totalCount}} {{user_lang.userword}}</div>
	<div style="text-align: center;" v-show = "showMoreString !== undefined && showMoreString !== ''">
<!--button type="button" class="btn" data-dismiss="modal" v-on:click="showMore()" 
style="color: #fff;height: 35px;padding: 0px 20px;background:#ccc;    margin-bottom: -70px;"
v-bind:class = "{disabled : loading}">{{user_lang.showmore}} </button-->
	</div>
  <div v-if="groupDeleted" class="no-group">{{user_lang.groupUnavailable}}</div>
 <vue-good-table id="table"
      :columns="columns"
      :rows="rows"
      :paginate="false"
      :paginateOnTop="true"
      :lineNumbers="false"
	  :responsive = "true"
	  :sort-options="{
      enabled: true,
      initialSortBy: {field: '_embedded.user.profile.updatelink', type: 'asc'}
      }">
  <div slot="emptystate" class="no-data">
    {{user_lang.noTableData}}
  </div>
	</vue-good-table>
	<div style="text-align: center;height: 65px;" v-show = "showMoreString !== undefined && showMoreString !== ''" >
<button type="button" class="btn" data-dismiss="modal" v-on:click="showMore()"
style="color: #fff;height: 35px;padding: 0px 20px;background:#ccc" v-bind:class = "{disabled : loading}">
{{user_lang.showmore}} </button>
	</div>
  </div>
</template>
<script>
import Vue from 'vue';
import VueGoodTable from 'vue-good-table';
import authapi from '@/helpers/auth-api'
// const apiUrl = process.env.API_URL;
// import adminapi from '@/helpers/admin-api'
import Spinner from '@/components/Spinner';
import { locale } from '@/i18n/locale.js'
import { EventBus } from '@/event-bus.js';
import idmApi from '@/idm-api'
const apiUrl = process.env.API_URL;
import storage from '@/helpers/storage'
const brandDetails = require('../brand-details.json');
// const onecargillapplicationgroupid = process.env.ONECARGILL_APPLICATION_GROUP_ID;
Vue.use(VueGoodTable);
export default {
  name: 'test',
  components: {
    Spinner
  },
  created() {
    var self = this
    setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
    // EventBus.$emit('lang', self.user_lang)
    setTimeout(() => {
      // this.getUserDetails();
    }, 300);
  },
  mounted() {
    var self = this
    this.loading = true;
    $("#table").on('click', '[id^="Atualizar"]', function(e) {
      self.onUpdateClick(e.target.id)
    })
    $("#table").on('click', '[id^="resetpwd"]', function(e) {
      self.onResetPwd(e.target.id)
    })
    $("#table").on('click', '[id^="reactivate"]', function(e) {
      self.onReactivate(e.target.id)
    })
    $("#table").on('click', '[id^="deactivate"]', function(e) {
      self.deactivateUserId(e)
    })
    $("#table").on('click', '[id^="unlock!^*$"]', function(e) {
      self.onUnlock(e.target.id)
    })
    $('#searchId').keypress(function(e) {
      if (self.loading && self.getUserType === 'app') {
        e.preventDefault();
        return false;
      }
    })
    self.$root.$on('refreshuserlist', function (language) {
      self.getUserDetails(self.getUserType)
    })
    EventBus.$on('lang', function (language) {
      self.user_lang = self.lang_obj[language]
      self.columns = [
        {
          label: self.user_lang.first_name,
          field: '_embedded.user.profile.updatelink',
          html: true
        },
        {
          label: self.user_lang.last_name,
          field: '_embedded.user.profile.lastName',
          html: false
        },
        {
          label: self.user_lang.emailAddress,
          field: '_embedded.user.profile.login',
          html: false
        },
        {
          label: self.user_lang.status,
          field: 'showstatus',
          html: true
          // filterable: true
        },
        {
          label: self.user_lang.action,
          field: 'deactivateAt',
          html: true
        },
        {
          label: '',
          field: 'resetpwd',
          html: true
        },
        {
          label: '',
          field: 'deleteUser',
          html: true
        }
      ]
      self.rows = []
      self.manipulateJSONtoRender(self.rawRows)
    })
    $(window).on('scroll', function () {
      self.scrollEventHandler()
    });
  },
  props: ['adminAppsArray', 'filterAppId', 'filterGroupId', 'usercreated', 'searchTerm', 'globalsearch', 'adminTo'],
  data() {
    return {
      brandDetails: brandDetails,
      showfloatingcount: false,
      lang: locale.lang,
      lang_obj: locale.lang_obj,
      defaultSort: {
        field: '_embedded.user.profile.updatelink',
        type: 'asc'
      },
      columns: [
        {
          label: 'First name',
          field: '_embedded.user.profile.updatelink',
          html: true
        },
        {
          label: 'Last name',
          field: '_embedded.user.profile.lastName',
          html: false
        },
        {
          label: 'E-mail',
          field: this.reverseTransformEmail,
          html: false
          // filterable: true
        },
        {
          label: 'Status',
          field: 'showstatus',
          html: true
          // filterable: true
        },
        {
          label: 'Actions',
          field: 'deactivateAt',
          html: true
        },
        {
          label: '',
          field: 'resetpwd',
          html: true
        },
        {
          label: '',
          field: 'deleteUser',
          html: true
        }
      ],
      rows: [],
      rawRows: [],
      // row: {},
      // searchTerm: '',
      loading: false,
      currentRole: '',
      currentTaxId: '',
      updateSuccess: false,
      emailAddress: '',
      resetSuccess: false,
      currentRoleCode: '',
      firstname: '',
      lastname: '',
      currentemailId: '',
      statusCode: '',
      currentId: '',
      currentSearchTerm: '',
      user_lang: {},
      resetSuccessMsg: "",
      selectedAppId: '',
      selectedGroupId: 'all',
      requestType: '',
      phone: '',
      showMoreString: undefined,
      totalCount: '',
      getUserType: 'app',
      randomMatch: '',
      adminToGroups: [],
      // statusAt: '',
      dxpList: [],
      nonDxpList: [],
      appList: [],
      errorAdminMsg: '',
      dxpnewcurrentId: '',
      dxpnewcurrentName: '',
      groupDeleted: false
    };
  },
  watch: {
    lang: function () {
    },
    filterAppId: function () {
      this.watchFilterAppId()
    },
    usercreated: function () {
      this.watchUserCeated()
    },
    filterGroupId: function () {
      this.watchFilterGroupId()
    },
    searchTerm: function (newVal, oldVal) {
      this.watchSearchTerm(newVal, oldVal);
    }
  },
  methods: {
    getDxpDetails() {
      let grpsOfUser = JSON.parse(storage.get('grpsOfUser'));
      let grpIds = [];
      grpsOfUser.map((grp) => {
        grpIds.push(grp.id);
      });
      return grpIds.join(',');
    },
    getListOfSuperUserApps(userId, adminGrp, action, id) {
      let self = this;
      self.dxpList = [];
      self.nonDxpList = [];
      self.loading = true;
      if (action.indexOf("resendInvite") > -1) {
        idmApi.getListOfSuperUserApps(`${apiUrl}/auth/apps`, self.email).then(function (response) {
          self.appList = response.data;
          idmApi.getDxpDetails(`${apiUrl}/auth/users/mapgroup?adminId=${adminGrp}&userId=${userId}`).then(function (response) {
            if (response.data && response.data.errorMessage) {
              self.errorAdminMsg = response.data.errorMessage;
              $('.adminErrorModal').modal('show');
            }
            if (response.data && response.data.dxpAppList) {
              response.data.dxpAppList.map((grp) => {
                self.appList.map((grpObj) => {
                  if (grpObj.id === grp) {
                    self.dxpList.push({
                      id: grpObj.id,
                      label: grpObj.label
                    });
                  }
                });
              });
            }
            if (response.data && response.data.nonDxpAppList) {
              response.data.nonDxpAppList.map((grp) => {
                self.appList.map((grpObj) => {
                  if (grpObj.id === grp) {
                    self.nonDxpList.push({
                      id: grpObj.id,
                      label: grpObj.label
                    });
                  }
                });
              });
            }
            if (self.dxpList.length > 0 && self.nonDxpList.length > 0) {
              $('.dxpmodal').modal('show');
            } if (self.dxpList.length === 0 && self.nonDxpList.length > 0) {
              $('.reactivatemodal').modal('show');
            } if (self.dxpList.length === 1 && self.nonDxpList.length === 0) {
              self.dxpnewcurrentId = self.dxpList[0].id;
              self.dxpnewcurrentName = self.dxpList[0].label;
              $('.reactivatedxpnewmodal').modal('show');
            } if (self.dxpList.length > 1 && self.nonDxpList.length === 0) {
              $('.newdxpmodal').modal('show');
            }
            self.loading = false;
          }).catch(err => {
            self.loading = false;
            console.log(err);
          });
        }).catch(err => {
          self.loading = false;
          console.log(err)
        })
      } else {
        idmApi.getDxpDetails(`${apiUrl}/auth/users/mapgroup?adminId=${adminGrp}&userId=${userId}`).then(function (response) {
          if (action.indexOf("resetpwd") > -1) {
            console.log("Works");
            if (response.data && response.data.errorMessage) {
              $('.permissiondeniedreset').modal('show');
            } else if (response.data && ((response.data.nonDxpAppList && response.data.nonDxpAppList.length > 0) || (response.data.dxpAppList && response.data.dxpAppList.length > 0))) {
              self.onResetPwdPermissionGranted(id)
            }
          } else if (action.indexOf("unlockAccount") > -1) {
            console.log("Unlock");
            if (response.data && response.data.errorMessage) {
              self.errorAdminMsg = response.data.errorMessage;
              $('.adminErrorModal').modal('show');
            } else {
              idmApi.unlockUser(`${apiUrl}/auth/users/${id}/unlock`).then(function (response) {
                self.loading = false;
                window.alert('Account has been unlocked')
                self.getUserDetails(self.getUserType)
              }).catch(err => {
                self.loading = false;
                window.alert('Account unlock failed or the account was not locked. Please try again later.')
                console.log("create Insert CF Error: ", err);
              });
            }
          } else if (action.indexOf("activate") > -1) {
            if (response.data && response.data.errorMessage) {
              self.errorAdminMsg = response.data.errorMessage;
              $('.adminErrorModal').modal('show');
            } else {
              if (id.target.getAttribute('act').toLowerCase() === 'activate') {
                self.statusCode = '0';
              } else {
                if (id.target.getAttribute('act').toLowerCase() === 'delete') {
                  self.requestType = 'deleteoktauser'
                } else {
                  self.requestType = 'deactivateoktauser'
                }
                self.statusCode = '1';
              }
              $('.ativateanddeactivaeemodal').modal('show');
            }
          }
          self.loading = false
        }).catch(err => {
          self.loading = false;
          console.log(err);
        });
      }
    },
    reverseTransformEmail(rows) {
      var em = rows._embedded.user.profile.login
      if (em.toLowerCase().indexOf('@identity.mycargill.com') > -1 || em.toLowerCase().indexOf('@whitelabel.cargill.com') > -1 || em.toLowerCase().indexOf('@partneridentity.okta-emea.com') > -1) {
        var brname = this.brandDetails.data.filter(function(n) {
          if (n.brandCode.toLowerCase() === em.substr(2, 3)) {
            return n
          }
        })
        em = em.substring(5, em.indexOf('@')).substring(0, em.substr(0, 2) - 1) + '@' + em.substring(5, em.indexOf('@')).substring(em.substr(0, 2) - 1) + ' [' + brname[0].brandName + ']'
      }
      return em
    },
    watchFilterGroupId() {
      this.selectedGroupId = this.filterGroupId
      this.getUserDetails('group');
    },
    watchUserCeated() {
      this.selectedAppId = this.filterAppId
      // this.getUserDetails('app');
    },
    watchFilterAppId() {
      this.selectedAppId = this.filterAppId
      this.getUserDetails('app');
    },
    scrollEventHandler() {
      var self = this
      var top = $(window).scrollTop()
      var temp = $('.showingnusers');
      if (temp.length) {
        var divBottom = $('.showingnusers').offset().top + $('.showingnusers').outerHeight();
        if (divBottom > top) {
          self.showfloatingcount = false
        } else {
          self.showfloatingcount = true
        }
      }
    },
    watchSearchTerm(newVal, oldVal) {
      var self = this
      console.log(self.searchTerm + ' ' + newVal)
      if (newVal.trim().length < oldVal.trim().length && (newVal.trim().length === 2 || newVal.trim().length === 0)) {
        self.loading = true;
        if (self.selectedGroupId === 'all') {
          self.getUserDetails('app')
        } else {
          self.$root.$emit('searchcleared')
          self.selectedGroupId = self.filterGroupId
          self.getUserDetails('group');
        }
      } else if (newVal.trim().length >= 3) {
        console.log('going to search: ' + self.searchTerm.trim())
        self.currentSearchTerm = self.searchTerm.trim();
        self.loading = true;
        self.getUserDetails('search', self.searchTerm.trim());
      }
    },
    assignUserLang() {
      var self = this
      self.user_lang = self.lang_obj[this.lang]
    },
    getUserDetailsInnerFn(random, response) {
      var self = this
      if (random === self.randomMatch) {
        self.loading = false;
        self.showMoreString = response.headers.page
        self.rawRows = response.data
        self.manipulateJSONtoRender(response.data)
      }
    },
    getUserDetails(type, st) {
      var self = this
      self.rawRows = []
      self.rows = []
      self.groupDeleted = false
      var delayTimer
      if (type === 'search') {
        // $('#grpdd').val('all')
        // self.selectedGroupId = 'all'
        // self.filterGroupId = 'all'
      }
      if (self.selectedAppId === '') {
        self.selectedAppId = this.filterAppId
      }
      self.loading = true;
      self.showMoreString = ''
      self.totalCount = ''
      type = self.globalsearch ? 'globalsearch' : type
      console.log("type " + type)
      self.getUserType = type
      var random = Math.random()
      self.randomMatch = random
      if (type === 'group' && self.selectedGroupId !== 'all') {
        self.loading = true;
        idmApi.getUserDetailsOfGroup(`${apiUrl}/auth/groups/${self.selectedGroupId}/users?limit=50`).then(response => {
          self.loading = true;
          idmApi.getGroupStats(`${apiUrl}/auth/groups/${self.selectedGroupId}`).then(response => {
            // var temp = $('.info')[0].innerHTML
            // var txt = temp.substring(0, temp.lastIndexOf(' '))
            // $('.info')[0].innerHTML = txt + ' ' + response.data._embedded.stats.usersCount
            self.totalCount = response.data._embedded.stats.usersCount
          }).catch(error => {
            console.log(error)
          })
          setTimeout(() => {
            self.getUserDetailsInnerFn(random, response)
          }, 0)
        }).catch(error => {
          console.log(error)
          if (error.response.status === 404) {
            self.loading = false
            self.groupDeleted = true
            console.log("The group is unavailable in Okta.")
          }
        })
      } else if (type === 'search' && self.searchTerm.trim() !== '' && self.selectedGroupId !== 'all' &&
        self.selectedGroupId !== '') { // even if group selected do app level search
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function() {
          self.loading = true;
          idmApi.getUserDetailsOfSearch(`${apiUrl}/auth/apps/${self.selectedAppId}/users?q=${self.searchTerm.trim()}`).then(response => {
          // idmApi.getUserDetailsOfSearch(`${apiUrl}/auth/users?q=${self.searchTerm.trim()}`).then(response => {
            setTimeout(() => {
              self.getUserDetailsInnerFn(random, response)
              // }
            }, 0)
          })
        }, 500);
      } else if (type === 'search' && self.searchTerm.trim() !== '' && self.selectedGroupId === 'all') {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function() {
          self.loading = true;
          idmApi.getUserDetailsOfSearch(`${apiUrl}/auth/apps/${self.selectedAppId}/users?q=${self.searchTerm.trim()}`).then(response => {
          /* idmApi.getUserDetailsOfSearch(`${apiUrl}/auth/users?q=${self.searchTerm.trim()}`).then(response => {
             var x = new Promise((resolve, reject) => {
              self.loading = true
              var arr = response.data.some(function(el, i) {
                idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${el.id}/groups`).then(function (response) {
                  for (var k = 0; k < response.data.length; k++) {
                    console.log(((response.data)[k]).id)
                    if (self.containsObject((response.data)[k], self.adminAppsArray)) {
                      return el
                    }
                  }
                  self.loading = false;
                }).catch(err => {
                  self.loading = false;
                  console.log("create Insert CF Error: ", err);
                });
                if (i === response.data.length - 1) {
                  resolve(arr)
                }
              });
            })
            x.then(function(e) { console.log(e) }) */
            setTimeout(() => {
              self.getUserDetailsInnerFn(random, response)
              // }
            }, 0)
          })
        }, 500);
      } else if (type !== 'search' && type !== 'group' && type !== 'globalsearch') {
        self.loading = true;
        idmApi.getUserDetailsOfApp(`${apiUrl}/auth/apps/${self.selectedAppId}/users?limit=50`).then(response => {
          setTimeout(() => {
            self.getUserDetailsInnerFn(random, response)
          }, 0)
        })
      } else if (type === 'group' && self.selectedGroupId === 'all') {
        self.loading = true;
        idmApi.getUserDetailsOfApp(`${apiUrl}/auth/apps/${self.selectedAppId}/users?limit=50`).then(response => {
          setTimeout(() => {
            self.getUserDetailsInnerFn(random, response)
          }, 0)
        })
      } else if (type === 'globalsearch') { // even if group selected do app level search
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function() {
          self.loading = true;
          idmApi.getUserDetailsOfSearch(`${apiUrl}/auth/users?search=id%20eq%20"${self.searchTerm.trim()}"
          %20or%20profile.firstName%20sw%20"${self.searchTerm.trim()}"
          %20or%20profile.lastName%20sw%20"${self.searchTerm.trim()}"
          %20or%20profile.email%20sw%20"${self.searchTerm.trim()}"&limit=50`).then(response => {
          // idmApi.getUserDetailsOfSearch(`${apiUrl}/auth/users?q=${self.searchTerm.trim()}`).then(response => {
            setTimeout(() => {
              self.getUserDetailsInnerFn(random, response)
              // }
            }, 0)
          })
        }, 500);
      } else {
        self.loading = false
      }
    },
    manipulateJSONtoRender(rows) {
      this.loading = true;
      rows = rows || this.rawRows
      var iscargill = false
      for (var c = 0; c < rows.length; c++) {
        this.loading = true;
        if (rows[c]['_embedded'] === undefined) {
          rows[c]['_embedded'] = {}
          rows[c]['_embedded']['user'] = {}
          rows[c]['_embedded']['user']['profile'] = rows[c]['profile']
        }
        var profile = rows[c]['_embedded'] === undefined ? rows[c]['profile'] : rows[c]['_embedded']['user']['profile']
        iscargill = profile['login'].toLowerCase().indexOf('@crgl-thirdparty.') > -1 ||
        profile['login'].toLowerCase().indexOf('@cargill.') > -1 || profile['login'].toLowerCase().indexOf('@awb') > -1
        profile['updatelink'] = ''
        if (rows[c]._embedded.user.status !== undefined) {
          rows[c].status = rows[c]._embedded.user.status
        } else {
          rows[c].status = rows[c].status
        }
        if (rows[c]['status'].toLowerCase() === 'deprovisioned' || rows[c]['status'].toLowerCase() === 'staged') {
          rows[c]['deactivateAt'] = '<a id="deactivate ' + '~' + rows[c]['id'] + '^' + profile['login'] +
          ' " style="text-decoration: underline;color: blue;" act="activate">' + this.user_lang.activateDeactivate.split('/')[0] + '</a>';
          rows[c]['deleteUser'] = '<a> <i id="deactivate ' + '~' + rows[c]['id'] + '^' + profile['login'] +
          ' " style="text-decoration: underline;color: blue;visibility:hidden !important;" act="delete" class="fa fa-trash deleteicon"></i> </a>';
          profile['updatelink'] = '<a id="Atualizar ' + '~$&' + profile['firstName'] + '!^*$' + profile['lastName'] +
          '!^*$' + rows[c]['id'] + '!^*$' + profile['login'] +
          '" style="text-decoration: underline;color: blue;" title = "Activate the user to view/update" alt="Activate the user to view/update">' +
          profile['firstName'] + '</a>';
        } else if (profile['login'] === storage.get('email')) {
          rows[c]['deactivateAt'] = '<a id="reactivate ' + '~' + rows[c]['status'] + '^' + profile['login'] + '~' +
          rows[c]['id'] + ' " style="text-decoration: underline;color: blue;">' + this.user_lang.reactivate + '</a>'; /* '<a class = "disabled" disabled = "disabled" id="deactivate ' + '~' + rows[c]['id'] + '^' +
          profile['login'] + ' " style="text-decoration: underline;color: blue;" act="deactivate">' + this.user_lang.activateDeactivate.split('/')[1] + '</a>'; */
          rows[c]['resetpwd'] = '<a class = "disabled" disabled = "disabled" id="resetpwd ' + '~' + rows[c]['status'] +
          '^' + profile['login'] + '~' + rows[c]['id'] + ' " style="text-decoration: underline;color: blue;">' + this.user_lang.resetpwd + '</a>';
          rows[c]['deleteUser'] = '';
          profile['updatelink'] = '<a class = "disabled" disabled = "disabled" id="Atualizar ' + '~$&' + profile['firstName'] +
          '!^*$' + profile['lastName'] + '!^*$' + rows[c]['id'] + '!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;">' +
          profile['firstName'] + '</a>';
        } else if (rows[c]['status'].toLowerCase() === 'provisioned') {
          rows[c]['deactivateAt'] = ''; /* '<a id="deactivate ' + '~' + rows[c]['id'] + '^' + profile['login'] +
          ' " style="text-decoration: underline;color: blue;" act="deactivate">' + this.user_lang.activateDeactivate.split('/')[1] + '</a>'; */
          rows[c]['resetpwd'] = '<a id="reactivate ' + '~' + rows[c]['status'] + '^' + profile['login'] + '~' +
          rows[c]['id'] + ' " style="text-decoration: underline;color: blue;">' + this.user_lang.reactivate + '</a>';
          rows[c]['deleteUser'] = '';
          profile['updatelink'] = '<a id="Atualizar ' + '~$&' + profile['firstName'] + '!^*$' + profile['lastName'] + '!^*$' +
          rows[c]['id'] + '!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;">' + profile['firstName'] + '</a>';
        } else {
          rows[c]['deactivateAt'] = '<a id="reactivate ' + '~' + rows[c]['status'] + '^' + profile['login'] + '~' +
          rows[c]['id'] + ' " style="text-decoration: underline;color: blue;">' + this.user_lang.reactivate + '</a>'; /* '<a id="deactivate ' + '~' + rows[c]['id'] + '^' + profile['login'] +
          ' " style="text-decoration: underline;color: blue;" act="deactivate">' + this.user_lang.activateDeactivate.split('/')[1] + '</a>'; */
          rows[c]['resetpwd'] = '<a id="resetpwd ' + '~' + rows[c]['status'] + '^' + profile['login'] + '~' +
          rows[c]['id'] + ' " style="text-decoration: underline;color: blue;">' + this.user_lang.resetpwd + '</a>';
          rows[c]['deleteUser'] = '';
          profile['updatelink'] = '<a id="Atualizar ' + '~$&' + profile['firstName'] + '!^*$' + profile['lastName'] +
          '!^*$' + rows[c]['id'] + '!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;">' + profile['firstName'] + '</a>';
        }
        if (iscargill) {
          rows[c]['deactivateAt'] = '';
          rows[c]['resetpwd'] = '';
          rows[c]['deleteUser'] = '';
          profile['updatelink'] = '<a id="Atualizar ' + '~$&' + profile['firstName'] + '!^*$' + profile['lastName'] + '!^*$' +
          rows[c]['id'] + '!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;">' + profile['firstName'] + '</a>';
        }
        if (rows[c].status === 'ACTIVE') {
          rows[c].showstatus = this.user_lang.activestatus
        } else if (rows[c].status === 'PROVISIONED') {
          rows[c].showstatus = this.user_lang.provisionedstatus
        } else if (rows[c].status === 'DEPROVISIONED') {
          rows[c].showstatus = this.user_lang.deprovisionedstatus
        } else if (rows[c].status === 'LOCKED_OUT') {
          rows[c].showstatus = rows[c].status + ' ' + '<a id="unlock!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;">Unlock</a>'
        } else {
          rows[c].showstatus = rows[c].status
        }
        if (c === rows.length - 1) {
          this.loading = false;
        }
      }
      if (rows.length === 0) {
        this.loading = false;
      }
      // this.searchTerm = this.currentSearchTerm;
      this.rows = rows.slice();
      if ($($('.table-bordered th')[0]).hasClass('sorting-asc')) {
        $('.table-bordered th')[0].click();
        $('.table-bordered th')[0].click();
      } else if ($($('.table-bordered th')[0]).hasClass('sorting-desc')) {
        $('.table-bordered th')[0].click();
      } else if ($('.table-bordered th')[0] !== undefined) {
        $('.table-bordered th')[0].click();
      }
    },
    deactivateUser: function(row) {
      var self = this;
      self.updateSuccess = false
      if (this.statusCode === '0') {
        authapi.activateOktaUser(self.currentId).then(response => {
          self.$root.$emit('activatesuccess', self.currentemailId)
          $('.ativateanddeactivaeemodal').modal('hide');
          setTimeout(() => {
            self.getUserDetails(self.getUserType)
          }, 500)
        }).catch(err => {
          console.log(err)
          setTimeout(() => {
            self.getUserDetails(self.getUserType)
          }, 500)
        })
      } else {
        authapi.deactivateOktaUser(self.currentId, self.requestType).then(response => {
          $('.ativateanddeactivaeemodal').modal('hide');
          if (self.requestType === 'deleteoktauser') {
            self.$root.$emit('deletesuccess', self.currentemailId)
          } else {
            self.$root.$emit('deactivatesuccess', self.currentemailId)
          }
          setTimeout(() => {
            self.getUserDetails(self.getUserType)
          }, 500)
        }).catch(err => {
          console.log(err)
          setTimeout(() => {
            self.getUserDetails(self.getUserType)
          }, 500)
        })
      }
    },
    deactivateUserId: function(e) {
      var self = this
      var temp = e.target.id.split('~')
      self.currentId = temp[1].split('^')[0];
      var id = e.target.id
      let userId = id.split('~')[1].split('^')[0];
      let adminGrp = self.getDxpDetails();
      self.emailAddress = id.split('~')[1].split('^').slice(-1).join('_').trim()
      if (self.emailAddress.toLowerCase().indexOf('@cargill.') > -1 || self.emailAddress.toLowerCase().indexOf('@crgl-thirdparty.') > -1 ||
      self.emailAddress.toLowerCase().indexOf('@awb') > -1) {
        $('.nonanoktausermodal').modal('show');
      } else {
        self.getListOfSuperUserApps(userId, adminGrp, "activate", e);
      }
      // Validation using App associated groups
      /* this.updateSuccess = false
      var temp = e.target.id.split('~')
      self.currentId = temp[1].split('^')[0];
      self.loading = true
      idmApi.getUserIdByEmail(`${apiUrl}/auth/users/${self.currentId}`).then(function (response) {
        self.loading = false
        var userStatus = response.data.status
        if (response.data.credentials.provider.type.toLowerCase() !== 'federation') {
          self.currentemailId = temp[1].split('^').slice(1).join('_').trim();
          self.loading = true;
          if (self.adminToGroups.length === 0) {
            self.adminToGroups = self.adminAppsArray.map(function(i) {
              if (self.adminTo.indexOf(i.appId) > -1) {
                return i._embedded.group.id
              }
            }).filter(j => j !== undefined)
          }
          idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${self.currentId}/groups`).then(function (response) {
            self.loading = false;
            var isNotPermissible = false
            isNotPermissible = userStatus !== 'STAGED' && response.data.some(i => (i.profile.name.toLowerCase().trim() !== 'everyone' && self.adminToGroups.indexOf(i.id) === -1))
            if (isNotPermissible) {
              $('.permissiondeniedmodal').modal('show');
            } else {
              if (e.target.getAttribute('act').toLowerCase() === 'activate') {
                self.statusCode = '0';
              } else {
                if (e.target.getAttribute('act').toLowerCase() === 'delete') {
                  self.requestType = 'deleteoktauser'
                } else {
                  self.requestType = 'deactivateoktauser'
                }
                self.statusCode = '1';
              }
              // setTimeout(() => {
              $('.ativateanddeactivaeemodal').modal('show');
              // }, 300);
            }
          });
        } else {
          $('.nonanoktausermodal').modal('show');
        }
      }); */
    },
    onUpdateClick: function(row) {
      var self = this
      self.loading = true
      console.log(row)
      idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${row.split('~$&')[1].split('!^*$')[2].trim()}/groups`).then(function (response) {
        // console.log(response)
        self.loading = false
        var ext = response.data.filter(x => x.profile.name.toLowerCase() === 'azure ad' || x.profile.name.toLowerCase() === 'azuread' ||
        x.profile.name.toLowerCase() === 'cargill internal identities')
        var isAzureORInternalIdentities = ext.length > 0 ? true : false // eslint-disable-line
        self.updateSuccess = false
        self.currentId = row.split('~$&')[1].split('!^*$')[2].trim();
        self.firstname = row.split('~$&')[1].split('!^*$')[0].trim();
        self.lastname = row.split('~$&')[1].split('!^*$')[1].trim();
        self.$root.$emit('updatetoggle', [self.firstname, self.lastname, row.split('~$&')[1].split('!^*$')[3].trim(), self.currentId, isAzureORInternalIdentities, true])
      }).catch(err => {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
      });
    },
    onReactivate: function(id) {
      var self = this
      let userId = id.split('~')[2];
      let adminGrp = self.getDxpDetails();
      self.emailAddress = id.split('~')[1].split('^').slice(-1).join('_').trim()
      if (self.emailAddress.toLowerCase().indexOf('@cargill.') > -1 || self.emailAddress.toLowerCase().indexOf('@crgl-thirdparty.') > -1 ||
      self.emailAddress.toLowerCase().indexOf('@awb') > -1) {
        $('.nonanoktausermodal').modal('show');
      } else {
        self.getListOfSuperUserApps(userId, adminGrp, "resendInvite");
      }
    },
    closeModal: function(modalName) {
      $(modalName).modal('hide');
    },
    onUnlock: function(id) {
      var self = this
      self.loading = true
      id = id.replace('unlock!^*$', '')
      let userId = id;
      let adminGrp = self.getDxpDetails();
      self.emailAddress = id;
      if (self.emailAddress.toLowerCase().indexOf('@cargill.') > -1 || self.emailAddress.toLowerCase().indexOf('@crgl-thirdparty.') > -1 ||
      self.emailAddress.toLowerCase().indexOf('@awb') > -1) {
        $('.nonanoktausermodal').modal('show');
      } else {
        self.getListOfSuperUserApps(userId, adminGrp, "unlockAccount", id);
      }
      // No validation for Unlocking
      /* id = id.replace('unlock!^*$', '')
      self.loading = true;
      idmApi.unlockUser(`${apiUrl}/auth/users/${id}/unlock`).then(function (response) {
        self.loading = false;
        window.alert('Account has been unlocked')
        self.getUserDetails(self.getUserType)
      }).catch(err => {
        self.loading = false;
        window.alert('Account unlock failed or the account was not locked. Please try again later.')
        console.log("create Insert CF Error: ", err);
      }); */
    },
    onResetPwd: function(id) {
      var self = this
      self.loading = true
      let userId = id.split('~')[2];
      let adminGrp = self.getDxpDetails();
      self.emailAddress = id.split('~')[1].split('^').slice(-1).join('_').trim()
      if (self.emailAddress.toLowerCase().indexOf('@cargill.') > -1 || self.emailAddress.toLowerCase().indexOf('@crgl-thirdparty.') > -1 ||
      self.emailAddress.toLowerCase().indexOf('@awb') > -1) {
        $('.nonanoktausermodal').modal('show');
      } else {
        self.getListOfSuperUserApps(userId, adminGrp, "resetpwd", id);
      }
      // Validation using App associated groups
      /* if (self.adminToGroups.length === 0) {
        self.adminToGroups = self.adminAppsArray.map(function(i) {
          if (self.adminTo.indexOf(i.appId) > -1) {
            return i._embedded.group.id
          }
        }).filter(j => j !== undefined)
        console.log('adminToGroups')
      }
      var uid = id.split('~')[2].trim()
      idmApi.getUserIdByEmail(`${apiUrl}/auth/users/${uid}`).then(function (response) {
        self.loading = false
        self.currentemailId = response.data.profile.login ? response.data.profile.login : response.data.profile.email
        if (response.data.credentials.provider.type.toLowerCase() !== 'federation') {
          idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${uid}/groups`).then(function (response) {
            self.loading = false;
            var isNotPermissible = true
            response.data.map(function (i) {
              console.log(i.id)
              if (i.profile.name.toLowerCase().trim() !== 'everyone' && self.adminToGroups.indexOf(i.id) > -1) {
                isNotPermissible = false
              }
            })
            if (isNotPermissible) {
              $('.permissiondeniedreset').modal('show');
            } else {
              self.onResetPwdPermissionGranted(id)
            }
          });
        } else {
          $('.nonanoktausermodal').modal('show');
        }
      }); */
    },
    onResetPwdPermissionGranted: function(id) {
      var self = this
      self.resetSuccess = false;
      self.resetSuccessMsg = self.user_lang.resetsuccesspopupmsg
      self.emailAddress = id.split('~')[1].split('^').slice(-1).join('_').trim()
      if (id.split('~')[1].split('^')[0].toLowerCase() === 'provisioned') {
        self.resetSuccess = true;
        self.resetSuccessMsg = self.user_lang.provisioned
      } else if (id.split('~')[1].split('^')[0].toLowerCase() === 'deprovisioned') {
        self.resetSuccess = true;
        self.resetSuccessMsg = self.user_lang.deprovisioned
      }
      $('.resetpwdemodal').modal('show');
      self.loading = false
      // this.getUserDetails();
      // $('.resetpwdemodal').modal('toggle');
    },
    resetPassword: function() {
      var self = this;
      idmApi.getUserIdByEmail(`${apiUrl}/auth/users/${self.emailAddress}`).then(function (response) {
        idmApi.resetPasswordByEmailByAdmin(`${apiUrl}/auth/users/${response.data.id}/resetpassword`, {}).then(response => {
          self.resetSuccess = true;
          $('.resetpwdemodal').modal('toggle');
          self.$root.$emit('resetsuccess')
          setTimeout(() => {
            self.getUserDetails(self.getUserType)
          }, 500)
        })
      })
    },
    adminErrorModalClick: function() {
      $('.adminErrorModal').modal('hide');
    },
    sendReInvite: function() {
      var self = this
      /* idmApi.getUserIdByEmail(`${apiUrl}/auth/users/${self.emailAddress}`).then(function (response) {
        idmApi.sendReInvite(`${apiUrl}/auth/users/${response.data.id}/reInvite`).then(response => {
          $('.reactivatemodal').modal('hide');
          self.$root.$emit('activatesuccess', self.emailAddress)
        }).catch(err => {
          $('.reactivatemodal').modal('hide');
          console.log(err);
        });
      }).catch(err => {
        $('.reactivatemodal').modal('hide');
        console.log(err);
      }); */
      idmApi.sendDxpReInvite(`${apiUrl}/auth/users/${self.emailAddress}/reInviteNew`).then(response => {
        $('.reactivatemodal').modal('hide');
        self.$root.$emit('activatesuccess', self.emailAddress);
      }).catch(err => {
        $('.reactivatemodal').modal('hide');
        console.log(err);
      });
    },
    sendDxpReInvite: function() {
      let self = this;
      let url = "";
      let selectedVal = $("input[name='activation']:checked").val();
      if (selectedVal === "0") {
        url = `${apiUrl}/auth/users/${self.emailAddress}/reInviteNew`;
      } else {
        url = `${apiUrl}/auth/users/${self.emailAddress}/reInviteNew?appId=${selectedVal}`;
      }
      idmApi.sendDxpReInvite(url).then(response => {
        $('.dxpmodal').modal('hide');
        $('.newdxpmodal').modal('hide');
        self.$root.$emit('activatesuccess', self.emailAddress);
      }).catch(err => {
        $('.dxpmodal').modal('hide');
        $('.newdxpmodal').modal('hide');
        console.log(err);
      });
    },
    sendNewDxpReInvite: function() {
      let self = this;
      idmApi.sendDxpReInvite(`${apiUrl}/auth/users/${self.emailAddress}/reInviteNew?appId=${this.dxpnewcurrentId}`).then(response => {
        $('.reactivatedxpnewmodal').modal('hide');
        self.dxpnewcurrentId = '';
        self.dxpnewcurrentName = '';
        self.$root.$emit('activatesuccess', self.emailAddress);
      }).catch(err => {
        $('.reactivatedxpnewmodal').modal('hide');
        self.dxpnewcurrentId = '';
        self.dxpnewcurrentName = '';
        console.log(err);
      });
    },
    containsObject(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].id === obj.id) {
          return true;
        }
      }
      return false;
    },
    showMore() {
      var self = this
      self.loading = true;
      idmApi.getUserDetailsOfApp(`${apiUrl}/auth${self.showMoreString}`).then(response => {
        setTimeout(() => {
          self.loading = false;
          self.showMoreString = response.headers.page
          self.rawRows = [...self.rawRows, ...response.data]
          self.manipulateJSONtoRender(self.rawRows)
        }, 300)
      })
    }
  }
};
</script>
<style>
th{
background: var(--theme-secondary) !important;
    color: white !important;
    font-weight: normal !important;
    font-size: 12px !important;
    padding: 20px 15px !important;
}
 tr:nth-of-type(odd) {
    /* background-color: rgba(0, 0, 0, 0.05); */
	}
th, td{border: 0px !important;font-size: 12px !important;
    padding: 20px 15px !important;}
tr{border-bottom: 8px solid #eceff1;}
th{cursor: pointer !important}
thead tr:nth-of-type(even) th{
    background-color: initial !important;
	}
#searchId {
    width: 130px !important;
    box-sizing: border-box !important;
    border: 1px solid var(--theme-primary) !important;
    border-radius: 0 !important;
    font-size: 16px !important;
    background-color: #f1f1f1 !important;
    background-position: 10px 10px !important;
    background-repeat: no-repeat !important;
    height: 50px !important;
	margin-bottom: 18px !important;
}
.btn-secondary {
    background-color: var(--theme-primary);;
    border-color: #00433c;
}
.btn-secondary:hover {
    background-color: #00524A;
    border-color: #00433c;
}
.btn {
    padding: 14px 24px;
    border: 0 none;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
}
.responsive {
    width: 100%;
    overflow-x: auto !important;
}
.deleteicon{
color: #2b2b2b !important;
    font-size: 18px;
    text-decoration: none !important;
}
.table.table-bordered td, .table-bordered th{padding : 15px 15px !important}
.table-bordered{margin-top: 5px;}
.table-footer{padding-bottom:5px !important; background-color: rgb(236, 239, 241) !important;
    border: 0px !important;margin-bottom:5px !important}
.page-btn span {margin-top:-4px !important;}
.table.table-bordered th:nth-child(5), .table.table-bordered th:nth-child(6), .table.table-bordered th:nth-child(7){pointer-events:none}
@media all and (-ms-high-contrast:none)
{
.input-adduser {
  height: auto !important;
}
 *::-ms-backdrop, #searchId { padding: 0px 10px !important } /* IE11 */
}
.disabled{pointer-events:none;opacity:0.6;}
.outOfView{position:fixed;left: 50%;
    top: 15px;
    background: rgba(101, 141, 27, 0.89) !important;
    padding: 10px 10px;
    border-radius: 8px;color: #fff;}
.v-hidden{opacity:0;}
td:first-child span {
    max-width: 100px !important;
    display: block;
}
td:nth-child(2) span {
    max-width: 100px !important;
    display: block;
}
.no-data {
  text-align: center;
  color: #808080;
}
.no-group {
  background: #546e7a;
  color: #fff;
  padding: 10px;
  margin: 15px 0px 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// UserTable.vue?24c2a83a